import { Box, Typography } from "@mui/material";
import React from "react";

export default function LayerContent({ article }) {
// Function to decode HTML entities
      function decodeHtml(html) {
        const textarea = document.createElement("textarea");
        textarea.innerHTML = html;
        return textarea.value;
      }


  return (
    <Box position={"relative"} overflow={"hidden"} width="100%" height="100%">
      <Box
        height="calc(100% - 80px)"
        overflow={"hidden"}
        paddingY={{ xs: 4, md: 6 }}
        paddingX={{ xs: 2, md: 4 }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={2}
          height="100%"
          overflow={"auto"}
        >
          <Typography
            fontSize={{ xs: "26px", md: "32px" }}
            color={"darkblue.main"}
            fontWeight={600}
            lineHeight={"normal"}
            variant="h1"
          >
            {article.title}
          </Typography>
          <Typography color={"darkblue.main"}>
            <div dangerouslySetInnerHTML={{ __html: decodeHtml(article.description) }} />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
